module.exports = __webpack_public_path__ + "img/checked.c9139a49.svg";